module.exports = __webpack_public_path__ + "static/media/Emily01_thumb.7a3a1e5a.png";